import axios from 'axios';

export const getWeatherData = async (plant, forecastTime, token) => {
  try {
    if (!plant || !plant.plant_id) {
      throw new Error(`No plant_id found`);
    }

    // Format datetime without timezone conversion - weather service treats as plant timezone
    const year = forecastTime.getFullYear();
    const month = String(forecastTime.getMonth() + 1).padStart(2, '0');
    const day = String(forecastTime.getDate()).padStart(2, '0');
    const hours = String(forecastTime.getHours()).padStart(2, '0');
    const minutes = String(forecastTime.getMinutes()).padStart(2, '0');
    const seconds = String(forecastTime.getSeconds()).padStart(2, '0');
    const localDateTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

    const headers = {};
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await axios.post('/api/v1/weather', {
      datetime: localDateTime,
      plant_id: String(plant.plant_id)
    }, {
      headers
    });

    const data = response.data;

    return {
      temperature: data.dry_bulb_temp,
      relativeHumidity: data.relative_humidity,
      moistureGrain: data.grains_of_moisture,
      atmosphericPressure: data.atmospheric_pressure
    };
  } catch (error) {
    console.error('Error fetching weather data:', error);
    throw error;
  }
}; 